import { inject, Injectable } from "@angular/core";
import { proxyBasePath } from "@app/core/config/url-paths.config";
import { ApiBaseService } from "@app/core/services/api-base.service";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";
import { AxPortalResponse } from "../models/responses.model";

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordApiService {

  #apiBaseService = inject(ApiBaseService)

  /**
   * Set new password for hash (kp)
   * @param urlHashId
   * @param newPassword
   */
  resetPasswordByHashId(urlHashId: string, newPassword: string): Observable<AxPortalResponse> {
    return this.#apiBaseService.anonymous('GET', `${proxyBasePath()}${environment.axApiProxyPath_Ax}/portal/Portal_PasswordSet?urlHashId=${urlHashId}&newPassword=${encodeURIComponent(newPassword)}`)
  }

  /**
   * Request a reset password link for kp account (anonymous)
   * @param username
   */
  resetPassword(username: string): Observable<AxPortalResponse> {
    return this.#apiBaseService.anonymous('GET', `${proxyBasePath()}${environment.axApiProxyPath_Ax}/portal/Do_ResetPassword?username=${username}`)
  }

  /**
   * Set new password for Proffsportalen.
   * @param urlHashId
   * @param newPassword
   */
  resetPasswordProffsportal(urlHashId: string, newPassword: string) {
    return this.#apiBaseService.anonymous('POST', `${proxyBasePath()}/api/proffsportal/ResetPassword`, { urlHashId, newPassword })
  }
}
